import { Box } from '@factorialco/deprecated-design-system'
import cn from 'classnames'

export type InlineEditableTitleProps = {
  value: string
  onChange: (value: string) => void
  placeholder: string
  ariaLabel: string
  style: React.CSSProperties
}

export const InlineEditableTitle = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  style,
}: InlineEditableTitleProps) => {
  const defaultStyle: object = {
    fieldSizing: 'content',
  }

  return (
    <Box width="full" overflowY="hidden" height="full">
      <textarea
        value={value}
        aria-label={ariaLabel}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        maxLength={100}
        className={cn(
          'w-full resize-none px-2 font-semibold',
          'disabled:text-f1-foreground [&::-webkit-search-cancel-button]:hidden',
          'focus:outline-none',
          'overflow-hidden',
          'placeholder:text-inherit placeholder:opacity-30'
        )}
        style={{ ...defaultStyle, ...style }}
        autoFocus
      />
    </Box>
  )
}
